'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _isDefined = require('../validators/isDefined');

var _isDefined2 = _interopRequireDefault(_isDefined);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: A class for creating fetch profiles
 * @class Profile
 */


var Profile = function () {
  /**
   * @description :: Creates an instance of Profile.
   * @param {String} profile :: The name of the profile
   * @memberof Profile
   */

  /**
   * @description :: Function for getting the profile
   * @static
   * @memberof Profile
   */

  /**
   * @description :: Saved profiles
   * @static
   * @memberof Profile
   */
  function Profile(profile) {
    (0, _classCallCheck3.default)(this, Profile);

    _initialiseProps.call(this);

    if (!profile) throw new Error('Please set a profile name');
    this.data.profile = profile;
  }
  /**
   * @description :: Setting the url attribute
   * @param {String} url :: Url string
   * @return {Object} :: self
   * @memberof Profile
   */

  /**
   * @description :: Object for saving instance settings
   * @memberof Profile
   */

  /**
   * @description :: Function for setting a profile
   * @static
   * @memberof Profile
   */

  /**
   * @description :: The default profile object
   * @static
   * @memberof Profile
   */


  (0, _createClass3.default)(Profile, [{
    key: 'url',
    value: function url(_url) {
      this.data.url = _url;
      Profile.setProfile(this.data);
      return this;
    }
    /**
     * @description :: Setting the query attribute
     * @param {Object} query :: Query object
     * @return {Object} :: self
     * @memberof Profile
     */

  }, {
    key: 'query',
    value: function query(_query) {
      this.data.query = [].concat((0, _toConsumableArray3.default)(this.data.query), [_query]);
      Profile.setProfile(this.data);
      return this;
    }
    /**
    * @description :: Setting the body attribute
    * @param {any} body :: Body attribute
    * @return {Object} :: self
    * @memberof Profile
    */

  }, {
    key: 'body',
    value: function body(_body) {
      this.data.body = _body;
      Profile.setProfile(this.data);
      return this;
    }
    /**
    * @description :: Setting the headers attribute
    * @param {Object} headers :: Headers object
    * @return {Object} :: self
    * @memberof Profile
    */

  }, {
    key: 'headers',
    value: function headers(_headers) {
      this.data.headers = [].concat((0, _toConsumableArray3.default)(this.data.headers), [_headers]);
      Profile.setProfile(this.data);
      return this;
    }
    /**
     * @description :: Setting the mode attribute
     * @param {String} mode :: Mode stirng
     * @return {Object} :: self
     * @memberof Profile
     */

  }, {
    key: 'mode',
    value: function mode(_mode) {
      this.data.mode = _mode;
      Profile.setProfile(this.data);
      return this;
    }
    /**
     * @description :: Setting the credentials attribute
     * @param {String} credentials :: Credentials string
     * @return {Object} :: self
     * @memberof Profile
     */

  }, {
    key: 'credentials',
    value: function credentials(_credentials) {
      this.data.credentials = _credentials;
      Profile.setProfile(this.data);
      return this;
    }
    /**
     * @description :: Setting the responder attribute
     * @param {Function} responder :: Responder function
     * @return {Object} :: self
     * @memberof Profile
     */

  }, {
    key: 'responder',
    value: function responder(_responder) {
      this.data.responder = _responder;
      Profile.setProfile(this.data);
      return this;
    }
  }]);
  return Profile;
}(); // Validators


Profile.DEFAULT_PROFILE = {
  url: '',
  method: null,
  profile: null,
  headers: [],
  query: [],
  body: null,
  credentials: null,
  mode: null,
  responder: null
};
Profile.profiles = {};

Profile.setProfile = function (_ref) {
  var profile = _ref.profile,
      data = (0, _objectWithoutProperties3.default)(_ref, ['profile']);
  return Profile.profiles[profile] = data;
};

Profile.getProfile = function (profile) {
  if ((0, _isDefined2.default)(profile) && Profile.profiles[profile] === undefined) {
    console.warn('Profile ' + profile + ' does not exist');
    return (0, _extends3.default)({}, Profile.DEFAULT_PROFILE);
  }

  if (!(0, _isDefined2.default)(profile)) return (0, _extends3.default)({}, Profile.DEFAULT_PROFILE);
  return Profile.profiles[profile];
};

var _initialiseProps = function _initialiseProps() {
  this.data = (0, _extends3.default)({}, Profile.DEFAULT_PROFILE);
};

exports.default = Profile;